import React from 'react';
import _ from 'underscore';

import Col from 'ui-library/bs/Col';
import {InputChangeEvent} from 'util/Types';

export interface PrimerRowOnlyFieldsProps {
  inputs: Array<{
    value: string;
    onChange: (e: InputChangeEvent) => void;
    placeholder: string | number | null;
  }>;
}

function PrimerRowOnlyFields(props: PrimerRowOnlyFieldsProps): JSX.Element {
  return (
    <div>
      {Array.from(props.inputs).map((input, key) => (
        <Col md={3} key={key}>
          <input
            {
              // TODO: refactor _.extend to be type-explicit
              ..._.extend({type: 'text'}, input) // eslint-disable-line no-restricted-syntax
            }
          />
        </Col>
      ))}
    </div>
  );
}

export default PrimerRowOnlyFields;
